import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Loader from 'components/Loader';
import { setEmailSubmissionSFMC } from 'index/AppActions';
import { isStaticRender } from 'helpers/ContentHelper';
import { fetchArticle } from 'components/Article/ArticleActions';
import { getArticleApiUrl } from 'components/Article/ArticleHelpers';
import Style from './Subscription.module.scss';

const Subscription = ({ accessToken, deviceId, fetchArticle, legal, panels }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const {
    subscriptionArticleIds,
    masked_discord_url = 'https://discord.com/invite/sKCTpcV6',
  } = window.ExternalConfig;
  const articleId = subscriptionArticleIds[0];
  const url = getArticleApiUrl(articleId);
  const regExp = /\(([^)]+)\)/;
  const legalUrls = legal?.split(regExp).filter(item => item.includes('http')) || ['', ''];
  const termsOfUse = legalUrls[0];
  const privacyPolicy = legalUrls[1];

  useEffect(() => {
    if (url && !isStaticRender()) {
      fetchArticle(url, accessToken, deviceId);
    }
  }, []);
  const image = panels?.member[0]?.items?.member[0]?.images?.logo;

  const signupHeadline = panels?.member[0]?.items?.member[0]?.headline;
  const successHeadline = 'Thank you for subscribing to the Maskverse.';
  const headline = isSubmitted ? successHeadline : signupHeadline;

  const onSubmit = async e => {
    e.preventDefault();
    const email = e.target.subscriptionEmail.value;
    if (!isLoading && email && !isSubmitted) {
      setIsLoading(true);
      setIsSubmitted(true);
      const url = window?.location?.href;
      await setEmailSubmissionSFMC({
        url,
        email,
        accessToken,
        deviceId,
        cb: () => {
          setIsLoading(false);
        },
      });
    }
  };
  const {
    subscription_emailPlaceholder = 'Enter Email Address',
    subscription_subscribeButton = 'Subscribe',
    subscription_submittedButton = 'Submitted',
    subscription_legalTextP1 = 'By clicking "Subscribe", you agree to the ',
    subscription_legalTextP2 = 'and agree to receive content and promotional communications from FOX.',
    subscription_discordText = 'Click Here to Join The Masked Discord Server!',
  } = window.Language;
  const buttonText = isSubmitted ? subscription_submittedButton : subscription_subscribeButton;
  const seriesRoute = '/the-masked-singer';
  const seriesText = 'Return to The Masked Singer';

  return (
    <div className={Style.container}>
      <div className={Style.content}>
        <div className={Style.logo}>
          <img src={image} alt="Subscription Logo" />
        </div>
        <div className={Style.headline}>{headline}</div>
        <form onSubmit={onSubmit} className={Style.subscriptionForm}>
          <div className={Style.formContainer}>
            {!isSubmitted ? (
              <>
                <input
                  autoCapitalize="none"
                  autoFocus
                  className={Style.emailInput}
                  type="email"
                  disabled={isSubmitted}
                  name="subscriptionEmail"
                  placeholder={subscription_emailPlaceholder}
                />
                <button disabled={isSubmitted} type="submit" className={Style.subscribeButton}>
                  {isLoading ? <Loader buttonLoader /> : buttonText}
                </button>
              </>
            ) : (
              <Link className={Style.seriesLink} to={seriesRoute}>
                {seriesText}
              </Link>
            )}
          </div>
          <div className={Style.legal}>
            {subscription_legalTextP1}
            <a href={termsOfUse}>Terms of Service, </a>
            <a href={privacyPolicy}>Privacy Policy, </a>
            {subscription_legalTextP2}
          </div>
        </form>
        <div className={Style.discordContainer}>
          <img src="/static/images/discord-logo.png" alt="discord-logo" />
          <a href={masked_discord_url} rel="noopener noreferrer" target="_blank">
            {subscription_discordText}
          </a>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  panels: state.article.panels,
  legal: state.footer.legal,
});

Subscription.fetchData = ({ store, accessToken }) => {
  const { subscriptionArticleIds } = window.ExternalConfig;
  const articleId = subscriptionArticleIds[0];
  const url = getArticleApiUrl(articleId);
  return store.dispatch(fetchArticle(url, accessToken));
};

Subscription.propTypes = {
  accessToken: PropTypes.string,
  deviceId: PropTypes.string,
  fetchArticle: PropTypes.func,
  legal: PropTypes.string,
  panels: PropTypes.shape({}),
};

export default connect(
  mapStateToProps,
  { fetchArticle },
)(Subscription);
